@if (get(multipleColumnsRow, 'multi_columns.multi_columns')) {
  <section class="p-0">
    @for (row of get(multipleColumnsRow, 'multi_columns.multi_columns', []); track row) {
      <div
        class="multi-columns"
        [ngStyle]="{
            'background-color': get(multipleColumnsRow, 'multi_columns.exxcom_color_picker', ''),
            'background-repeat': 'no-repeat',
            'margin-bottom': get(multipleColumnsRow, 'multi_columns.exxcom_color_picker', '').length > 0 ? '24px' : ''
        }"
        >
        <div class="container d-flex flex-column px-2" [class]="get(row, 'columns', '') != 3 ? '' : 'new-container'">
          <div>
            @if (multipleColumnsRow?.multi_columns?.title) {
              <div class="category-top-title d-flex flex-row justify-content-center pb-2">
                <div class="container d-flex flex-row justify-content-center">
                  <h2 class="text-center title-width">
                    {{ multipleColumnsRow?.multi_columns?.title }}
                  </h2>
                </div>
              </div>
            }
            @if (multipleColumnsRow?.multi_columns?.free_form_content_top) {
              <div
                [innerHTML]="multipleColumnsRow?.multi_columns?.free_form_content_top | safe: 'html'"
              ></div>
            }
            @if (multipleColumnsRow?.multi_columns?.free_form_content) {
              <div
                [innerHTML]="multipleColumnsRow?.multi_columns?.free_form_content | safe: 'html'"
              ></div>
            }
          </div>
          @if (get(row, 'columns', '')) {
            <div>
              @if (get(row, 'cards', [])) {
                <div class="grid partial-grid container-padless">
                  @for (column of get(row, 'cards', ''); track column) {
                    <div
                      class="my-2 g-col-12"
                      [class.g-col-md-3]="get(row, 'columns', '') == 4"
                      [class.g-col-md-4]="get(row, 'columns', '') == 3"
                      [class.g-col-md-6]="get(row, 'columns', '') == 2"
                      [class.g-col-md-12]="get(row, 'columns', '') == 1"
                      >
                      <div class="d-flex flex-row align-items-start card-1">
                        <div class="img-container d-flex align-items-center">
                          <img [src]="getWebpImg(get(column, 'card_image.href', ''))" [alt]="get(column, 'card_image.title', '')" />
                        </div>
                        <div class="text-container col-md-12">
                          @if (get(column, 'card_title', '')) {
                            <h4>
                              {{ get(column, 'card_title', '') }}
                            </h4>
                          }
                          <div [innerHTML]="get(column, 'card_copy', '') | safe: 'html'"></div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
              @if (get(row, 'misc_', [])) {
                <div class="grid partial-grid container-padless">
                  @for (column of get(row, 'misc_', ''); track column) {
                    <div
                      class="my-2 g-col-12"
                      [class.g-col-md-3]="get(row, 'columns', '') == 4"
                      [class.g-col-md-4]="get(row, 'columns', '') == 3"
                      [class.g-col-md-6]="get(row, 'columns', '') == 2"
                      [class.g-col-md-12]="get(row, 'columns', '') == 1"
                      >
                      <div class="misc-container d-flex flex-column">
                        <!-- WITH IMAGE ENLARGEMENT -->
                        @if (get(column, 'image_enlargement', '')) {
                          <!-- NO REDIRECT LINK -->
                          @if (get(column, 'image.href', '') && !get(column, 'image_redirect_link', '')) {
                            <app-image-zoom
                              [image]="getWebpImg(get(column, 'image.href', ''))"
                              [altText]="get(column, 'image.title', '')"
                            ></app-image-zoom>
                          }
                          <!-- REDIRECT LINK -->
                          @if (get(column, 'image.href', '') && get(column, 'image_redirect_link', '')) {
                            <a
                              class="misc-image"
                              [href]="get(column, 'image_redirect_link', '')"
                              target="_blank"
                              rel="noopener noreferrer"
                              >
                              @if (get(column, 'image.href', '') && !get(column, 'image_redirect_link', '')) {
                                <app-image-zoom
                                  [image]="getWebpImg(get(column, 'image.href', ''))"
                                  [altText]="get(column, 'image.title', '')"
                                ></app-image-zoom>
                              }
                            </a>
                          }
                        }
                        <!-- WITHOUT IMAGE ENLARGEMENT -->
                        @if (!get(column, 'image_enlargement', '')) {
                          <!-- NO REDIRECT LINK -->
                          @if (get(column, 'image.href', '') && !get(column, 'image_redirect_link', '')) {
                            <img
                              class="misc-image"
                              [src]="getWebpImg(get(column, 'image.href', ''))"
                              [alt]="get(column, 'image.title', '')"
                              />
                          }
                          <!-- REDIRECT LINK -->
                          @if (get(column, 'image.href', '') && get(column, 'image_redirect_link', '')) {
                            <a
                              class="misc-image"
                              [href]="get(column, 'image_redirect_link', '')"
                              target="_blank"
                              rel="noopener noreferrer"
                              >
                              <img [src]="getWebpImg(get(column, 'image.href', ''))" [alt]="get(column, 'image.title', '')" />
                            </a>
                          }
                        }
                        @if (get(column, 'card_title', '')) {
                          <h4 class="text-center">
                            {{ get(column, 'title', '') }}
                          </h4>
                        }
                        <div class="misc-inner-html" [innerHTML]="get(column, 'rich_text_editor', '') | safe: 'html'"></div>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </section>
}
@if (get(multipleColumnsRow, 'multi_columns.split_line', '')) {
  <hr class="m-0 mb-3" />
}
